module.exports = __webpack_public_path__ + "e7230d9c4195a4989db1b13e6e7cf66a.svg";